// extracted by mini-css-extract-plugin
export default {"floatingIcon":"ChatFloat_floatingIcon__mEuR9"};